import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}\n",{ moduleName: "editor/restricted/songs/folder/template.hbs" })